import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BentoBrand } from "schemas/dashboard";

import QuickSendIndividualDrawer from "features/Influencer/QuickSendIndividualDrawer";

import styles from "../styles";
import DraftLoader from "./DraftLoader";

interface IProps {
  handleBack: () => void;
  handleSkip?: () => void;
  loading: boolean;
  selectedBrand?: BentoBrand;
  fetchEmailPreview: (bentoBrandId: number) => void;
}

export default function EmailBrandForm({
  handleBack,
  handleSkip,
  loading,
  selectedBrand,
  fetchEmailPreview,
}: IProps) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { brandId } = useParams();
  const { currentOrg } = useContext(OrganizationUserContext);
  const bentoBrandId = Number(brandId) || selectedBrand?.id;

  const { fetchOutreachTemplates } = useContext(OutreachTemplatesContext);

  useEffect(() => {
    if (bentoBrandId) fetchEmailPreview(bentoBrandId);
    if (currentOrg?.id) {
      fetchOutreachTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bentoBrandId, currentOrg?.id]);

  return (
    <>
      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Typography gutterBottom variant={isMobileScreen ? "h4" : "h3"}>
          <Box
            component="i"
            color="secondary.dark"
            sx={{ pr: 2 }}
            className="fa-solid fa-paper-plane"
          />
          Send your first pitch!
        </Typography>
        {selectedBrand && (
          <Typography>
            You’re almost there! Let's get your first pitch ready for{" "}
            <strong>{selectedBrand.normalizedName}</strong>.
          </Typography>
        )}
      </Box>
      <Box sx={styles.quickSendWrapper}>
        {loading && (
          <Box sx={styles.loaderWrapper}>
            <DraftLoader />
          </Box>
        )}
        {!loading && <QuickSendIndividualDrawer />}
      </Box>

      <Grid item xs="auto" container columnGap={1}>
        <Grid item xs="auto">
          <Button color="secondary" onClick={handleBack} disableElevation>
            Back
          </Button>
        </Grid>
        <Grid item xs></Grid>
        {handleSkip && (
          <Grid item xs="auto">
            <Button onClick={handleSkip} disableElevation color="secondary">
              Skip
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
}
